import React from 'react'
import { inject, observer } from 'mobx-react'
import { WMSTileLayer } from 'react-leaflet'
// Renders boundary density overlays. WMSTileLayer
// uses the props we pass it to construct tile URLs which
// geoserver serves.
const BoundaryOverlays = ({ uiStore, selectionStore, onFirstLoad }) => {
  const selectedBoundaries = selectionStore.item && selectionStore.item.selectedBoundaries
  if (!selectedBoundaries || selectedBoundaries.length === 0) return null

  const boundaryIds = selectedBoundaries
    .map(b => b.remote_db_id || b.id || b.code || b.name)
    .filter(Boolean)
    .sort()
    .join('-') || 'unknown'

  return (
    <WMSTileLayer
      noWrap
      url={uiStore.boundaryOverlayURL}
      layers={`${uiStore.zipCodeBoundaryLayer},${uiStore.boundaryLayer}`}
      CQL_FILTER={`id in (${selectedBoundaries.map(b => b.remote_db_id).join(',')})`}
      // Keep selected boundaries visible while making the highlight less intense.
      opacity={0.58}
      zIndex={2}
      transparent
      tiled
      format='image/png'
      // tilesOrigin={[-90, -180]}
      layerId={`boundary-${selectionStore.item.useZipCodes ? 'zip' : 'state'}-${boundaryIds}`}
      onload={onFirstLoad}
    />
  )
}

export default inject('uiStore', 'selectionStore')(
  observer(BoundaryOverlays)
)
